export const saveRecords = (
  setter: (records: any) => Promise<any>,
  records: { [key: string]: any } = {},
  previous: { [key: string]: any } = {},
): Promise<{ [key: string]: any }> => {
  return setter({ ...previous, ...records });
};

export const saveRecord = (
  key: string,
  record: any,
  setter: (records: any) => Promise<any>,
  previous: { [key: string]: any } = {},
): Promise<any> => {
  return setter({ ...previous, [key]: record });
};

export const patchRecord = async (
  key: any,
  record: any,
  fieldsToPatch: any,
  previous: any,
  setter: (records: any) => Promise<any>,
): Promise<any> => {
  await setter({ ...previous, [key]: { ...record, ...fieldsToPatch } });
  return { ...record, ...fieldsToPatch };
};

export const getByValue = (
  key: string,
  value: any,
  records: { [key: string]: any } = {},
): any => {
  return Object.values(records).find((item: any) => item[key] === value);
};

export const getByValues = (
  keys: string[],
  values: any[],
  records: { [key: string]: any } = {},
): any => {
  return Object.values(records).find((item: any) =>
    keys.every((key, i) => item[key] === values[i]),
  );
};

export const getFilteredByValues = (
  keys: string[],
  values: any[],
  records: { [key: string]: any } = {},
): { [key: string]: any } => {
  return Object.fromEntries(
    Object.entries(records).filter(([, item]: any) =>
      keys.every((key, i) => item[key] === values[i]),
    ),
  );
};

export const getFilteredByValue = (
  key: string,
  value: any,
  records: { [key: string]: any } = {},
): { [key: string]: any } => {
  return getFilteredByValues([key], [value], records);
};

export const getFilteredByMultiValue = (
  key: string,
  values: any[],
  records: { [key: string]: any } = {},
): { [key: string]: any } => {
  return Object.fromEntries(
    Object.entries(records).filter(([, item]: any) =>
      values.includes(item[key]),
    ),
  );
};

export const removeMultiple = (
  keys: string[],
  setter: (records: any) => Promise<any>,
  records: { [key: string]: any } = {},
): Promise<{ [key: string]: any }> => {
  return setter(
    keys.reduce((acc: any, key: string) => {
      const { [key]: value, ...rest } = acc;
      return rest;
    }, records),
  );
};

export const remove = (
  key: string,
  setter: (records: any) => Promise<any>,
  records: { [key: string]: any } = {},
): Promise<{ [key: string]: any }> => {
  return removeMultiple([key], setter, records);
};
